var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.73,
    height: 17.803,
    viewBox: "0 0 19.73 17.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2a2a2a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.035,249H97.649a.649.649,0,1,0,0,1.3h1.385a.649.649,0,1,0,0-1.3Z",
    transform: "translate(-93.326 -240.442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.035,313H97.649a.649.649,0,1,0,0,1.3h1.385a.649.649,0,1,0,0-1.3Z",
    transform: "translate(-93.326 -301.997)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.035,377H97.649a.649.649,0,0,0,0,1.3h1.385a.649.649,0,0,0,0-1.3Z",
    transform: "translate(-93.326 -363.552)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M227.035,249h-1.385a.649.649,0,0,0,0,1.3h1.385a.649.649,0,1,0,0-1.3Z",
    transform: "translate(-216.477 -240.442)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M227.035,313h-1.385a.649.649,0,1,0,0,1.3h1.385a.649.649,0,0,0,0-1.3Z",
    transform: "translate(-216.477 -301.997)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M227.035,377h-1.385a.649.649,0,1,0,0,1.3h1.385a.649.649,0,0,0,0-1.3Z",
    transform: "translate(-216.477 -363.552)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M355.035,249h-1.385a.649.649,0,1,0,0,1.3h1.385a.649.649,0,1,0,0-1.3Z",
    transform: "translate(-339.629 -240.442)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M355.035,313h-1.385a.649.649,0,1,0,0,1.3h1.385a.649.649,0,1,0,0-1.3Z",
    transform: "translate(-339.629 -301.997)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M355.035,377h-1.385a.649.649,0,1,0,0,1.3h1.385a.649.649,0,1,0,0-1.3Z",
    transform: "translate(-339.629 -363.552)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,26.541H16.608v-.963a.578.578,0,1,0-1.156,0v.963H10.443v-.963a.578.578,0,1,0-1.156,0v.963H4.277v-.963a.578.578,0,1,0-1.156,0v.963H1.734A1.736,1.736,0,0,0,0,28.275V41.069A1.736,1.736,0,0,0,1.734,42.8H18a1.736,1.736,0,0,0,1.734-1.734V28.275A1.736,1.736,0,0,0,18,26.541ZM1.156,28.275a.579.579,0,0,1,.578-.578H3.121v.963a.578.578,0,1,0,1.156,0V27.7H9.287v.963a.578.578,0,1,0,1.156,0V27.7h5.009v.963a.578.578,0,1,0,1.156,0V27.7H18a.579.579,0,0,1,.578.578v2.274H1.156ZM18,41.647H1.734a.579.579,0,0,1-.578-.578V31.7H18.574v9.364A.579.579,0,0,1,18,41.647Z",
    transform: "translate(0 -25)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a9cca23f2055f4dba43ddc4be1381b8a.svg";
export { ForwardRef as ReactComponent };